(() => {
  const syncColorLabels = () => {
    document.querySelectorAll('.template-product .easify-product-options .po-option-root').forEach((option) => {
      const heading = option.querySelector('.po-label-label');
      if (!heading || !/\bcolor\b/i.test(heading.textContent || '')) return;

      option.querySelectorAll('.po-imageSwatches-optionItem').forEach((item) => {
        if (item.querySelector('.po-optionSwatch-labelText, .tyb-color-swatch-name')) return;

        const image = item.querySelector('img[alt]');
        const name = image?.alt?.trim();
        if (!name) return;

        const label = document.createElement('span');
        label.className = 'tyb-color-swatch-name';
        label.textContent = name;
        item.append(label);
      });
    });
  };

  const start = () => {
    syncColorLabels();
    new MutationObserver(syncColorLabels).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
